import { useMutation, useQuery } from "react-query";
import { useGraphqlRequestConfigContext } from "../../contexts/GraphqlRequestConfig";
import { createConversationId } from "../../index";
import fetchQuery from "../../utils/fetch";
const createRequestConfigData = (config, commonHeaders) => ({
  endpoint: config.endpoint,
  method: config.method || "POST",
  headers: {
    ...commonHeaders,
    ...config.headers || {}
  }
});
const generateUseGraphqlQuery = (name, version) => {
  const commonHeaders = {
    ConversationId: createConversationId(name),
    "Content-Type": "application/json",
    "x-client-name": name,
    "x-app-version": version
  };
  const useGraphqlQuery = (gqlQuery, variables, config, abortSignal) => {
    const defaultConfig = useGraphqlRequestConfigContext();
    const { requestConfig, ...reactQueryOptions } = config || {};
    const requestConfigData = createRequestConfigData({ ...defaultConfig, ...requestConfig }, commonHeaders);
    return useQuery([gqlQuery, variables, requestConfigData], (query) => fetchQuery({ ...query, signal: abortSignal }), reactQueryOptions);
  };
  const useGraphqlMutation = (gqlQuery, config) => {
    const defaultConfig = useGraphqlRequestConfigContext();
    const { requestConfig, ...reactQueryOptions } = config || {};
    const requestConfigData = createRequestConfigData({ ...defaultConfig, ...requestConfig }, commonHeaders);
    return useMutation((variables) => fetchQuery({ queryKey: [gqlQuery, variables, requestConfigData] }), reactQueryOptions);
  };
  return { useGraphqlQuery, useGraphqlMutation };
};
var useGraphqlQuery_default = generateUseGraphqlQuery;
export {
  useGraphqlQuery_default as default
};
